/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-lable-primary[_ngcontent-%COMP%] {\n  padding: 0.4em; }\n  .btn-lable-primary[_ngcontent-%COMP%]:hover {\n    text-decoration: none;\n    color: #fff; }"];
export { styles as styles };
